import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class Creatinine extends mixins(GraphRanges) {
  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("graph", patientNamespace)
  graph!: any;

  get charts(): MultiChartConfig[] {
    return [
      {
        title: "Creatinine",
        data: this.graph(["Creatinine"]),
        suggestedMax: 2,
        library: this.creatinineConfig
      },
      {
        title: "BUN",
        data: this.graph(["BUN"]),
        suggestedMax: 30
      }
    ];
  }

  get creatinineConfig() {
    return {
      scales: {
        yAxes: [
          {
            ticks: {
              stepSize: 2
            }
          }
        ]
      }
    };
  }
}
